import React, { useState, useEffect, useMemo, useRef } from "react";
import { Button, Form, Dropdown, Label, List, Icon, Modal } from "semantic-ui-react";
import { map, truncate, isEmpty, concat, without, trim, toLower, includes, isEqual, get } from "lodash";
import TextareaAutosize from "react-textarea-autosize";
import Joi from "joi";
import PropTypes from "prop-types";

// redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

// Components
import Text from "@Components/Text";
import Input from "@Components/Input";
// Modals
import ConfirmModal from "@Modals/ConfirmModal";
import ImageView from "@Modals/ImageView";

// utils
import { compressImage } from "@Utils/functionality";
import { boolOnline, archiveOption } from "../../staticData";

// Styles
import styles from "./styles.module.css";

const HashtagCrud = ({ modalCrud, tableValue, userName, hashtagArray, apiData, onClose, dispatch }) => {
	const schema = Joi.object().keys({
		hashtagError: Joi.string().messages({
			"string.empty": "Hashtag es un campo requerido",
		}),
		messageArea: Joi.string().messages({
			"string.empty": "Mensaje es un campo requerido",
		}),
		stateV: Joi.string().messages({
			"string.empty": "Estado es un campo requerido",
		}),
		fileVerificacion: Joi.string().messages({
			"string.empty": "Archivo es un campo requerido",
		}),
	});
	const [initialFormData, setInitialFormData] = useState({});
	const [openImage, setOpenImage] = useState(false);
	const [hastagDeletRepeat, setHastagDeletRepeat] = useState(false);
	const [modalOption, setModalOption] = useState("");

	const [formData, setFormData] = useState({
		admin: "",
		stateV: "",
		formatFile: ".txt",
		typeRadio: "Text",
		hashtag: "",
		hashtagData: [],
		file: [],
		fileText: "Ningún archivo seleccionado",
		fileData: [],
		messageArea: "",
	});
	const [errors, setErrors] = useState({
		fileVerificacion: "",
		hashtagError: "",
		stateV: "",
		messageArea: "",
	});
	const [fileImage, setFileImage] = useState("");
	const [open, setOpen] = useState(false);
	const fileInputRef = useRef(null);

	useEffect(() => {
		setModalOption(modalCrud);

		if (modalCrud !== "Add") {
			setFormData({
				...formData,
				stateV: get(tableValue, "isActive", ""),
				admin: userName,
				messageArea: get(tableValue, "text", ""),
				hashtagData: get(tableValue, "hashtag", []),
				file: false,
				fileText: get(tableValue, "uri", "Ningún archivo seleccionado"),
				fileData: get(tableValue, "uri", {}),

				typeRadio: get(tableValue, "type", "Text"),
			});
			setFileImage(get(tableValue, "uri", {}));
			setInitialFormData({
				...formData,
				stateV: get(tableValue, "isActive", ""),
				admin: userName,
				messageArea: get(tableValue, "text", ""),
				hashtagData: get(tableValue, "hashtag", []),
				file: false,
				fileText: get(tableValue, "uri", "Ningún archivo seleccionado"),
				fileData: get(tableValue, "uri", {}),
				typeRadio: get(tableValue, "type", "Text"),
			});
		} else {
			setInitialFormData({
				...formData,
				stateV: true,

				admin: userName,
				fileText: "Ningún archivo seleccionado",
			});
			setFormData({
				...formData,

				stateV: true,

				admin: userName,
				fileText: "Ningún archivo seleccionado",
			});
		}
	}, [tableValue, hashtagArray]);
	// save handlers
	const savedData = async () => {
		let hashtagError = "null";
		if (isEmpty(formData.hashtagData)) {
			hashtagError = "";
		}

		let fileVerificacion = "ejemplo";
		if (formData.typeRadio !== "Text" && isEqual(formData.fileData, {})) {
			fileVerificacion = "";
		}
		let validation = {};
		if (formData.typeRadio === "Text") {
			validation = schema.validate({ fileVerificacion, messageArea: formData.messageArea, hashtagError }, { abortEarly: false });
		} else {
			validation = schema.validate({ fileVerificacion, hashtagError }, { abortEarly: false });
		}
		if (validation.error) {
			const { details } = validation.error;
			let errorsVal = {
				hashtagError: "",

				messageArea: "",
			};
			map(details, (item) => {
				errorsVal = { ...errorsVal, [item.context.key]: item.message };
			});
			setErrors(errorsVal);
		} else {
			const data = {
				isActive: formData.stateV,
				hashtag: formData.hashtagData,
				type: formData.typeRadio,
				text: trim(formData.messageArea),
				file: formData.fileData,
			};
			// let file = formData.fileData;

			// if (isEqual(formData.fileData, {}) || isEqual(formData.fileData, get(tableValue, "uri", {}))) {
			// 	file = false;
			// }

			if (modalOption !== "Add") {
				const dataEdit = await dispatch(genericAction({ method: "patch", route: `hashtag/${tableValue.id}`, body: data }));
				if (!isEmpty(dataEdit)) {
					apiData("Edit");
				}
			} else {
				const dataAdd = await dispatch(genericAction({ method: "post", route: `hashtag`, body: data }));
				if (!isEmpty(dataAdd)) {
					setFormData({
						admin: userName,
						stateV: true,
						formatFile: ".txt",
						typeRadio: "Text",
						hashtag: "",
						hashtagData: [],
						file: [],
						fileText: "Ningún archivo seleccionado",
						fileData: [],
						messageArea: "",
					});
				}
				apiData("Add");
			}

			setErrors({
				fileVerificacion: "",
				hashtagError: "",
				stateV: true,
				messageArea: "",
			});
		}
	};
	// archive handlers
	const archiveOptionHandler = (event, { name, value }) => {
		if (value === "Document") {
			setFormData({
				...formData,
				[name]: value,
				messageArea: "",
				fileText: "Ningún Documento seleccionado",
				fileData: {},
			});
		} else {
			if (value === "Image") {
				setFormData({
					...formData,
					[name]: value,

					fileText: "Ningún Documento seleccionado",
					fileData: {},
				});
				setErrors({ ...errors, fileVerificacion: "", messageArea: errors.messageArea });
			} else if (value === "Text") {
				setFormData({
					...formData,
					fileData: {},
					fileText: "Ningún Documento seleccionado",
					[name]: value,
				});
			}
			setErrors({ ...errors, fileVerificacion: "", messageArea: errors.messageArea });
		}
	};
	const concatStringArchive = (string) => {
		if (!isEmpty(string)) {
			return truncate(string, {
				length: 30,
				omission: "...",
			});
		}
		return "Ningún Documento seleccionado";
	};
	const convertStringArchive = (string) => {
		switch (string) {
			case "Image":
				return "image/*";
			case "Document":
				return "*/*";
			case "Text":
				return ".txt";
			default:
				return "";
		}
	};
	const convertStringTitle = (string) => {
		switch (string) {
			case "Image":
				return "Imagen";

			case "Document":
				return "Archivo";

			case "Text":
				return "Desactivado";

			default:
				return "";
		}
	};

	// input handlers
	const handleInput = (e) => {
		const { name, value } = e.target;

		setFormData({
			...formData,
			[name]: value,
		});
	};
	const fileChange = async (e) => {
		if (e.target.files[0] !== undefined) {
			/// filtro
			let filterName = "";
			let filterBool = false;
			switch (formData.typeRadio) {
				case "Document":
					if (e.target.files[0].type === "application/pdf") {
						filterBool = true;
					} else {
						filterName = "Document invalido solo se aceptan documentos (.pdf)";
					}
					break;
				case "Image":
					if (
						truncate(e.target.files[0].type, {
							length: 5,
							omission: "",
						}) === "image"
					) {
						filterBool = true;
					} else {
						filterName = "Document invalido solo se aceptan Image";
					}
					break;
				case "Text":
					if (e.target.files[0].type === "text/plain") {
						filterBool = true;
					} else {
						filterName = "Document invalido solo se aceptan documentos (.txt)";
					}

					break;
				default:
					break;
			}

			if (!filterBool) {
				setFormData({
					...formData,
					fileText: "Ningún Document seleccionado",
				});
				setErrors({ ...errors, messageArea: "", fileVerificacion: filterName });
			} else {
				const fileTextTrunca = truncate(e.target.files[0].name, {
					length: 20,
					omission: "...",
				});
				const fileArchive = e.target.files[0];
				const imageRegex = /image.*/g;
				let fileVal = null;
				const isImage = imageRegex.test(fileArchive.type);
				if (isImage) {
					fileVal = await compressImage(fileArchive);
				} else {
					fileVal = fileArchive;
				}
				if (fileVal.size < 10 * 1024 * 1024) {
					setFormData({
						...formData,
						fileText: fileTextTrunca,
						fileData: fileVal,
					});
					setErrors({ ...errors, fileVerificacion: "" });
					const reader = new FileReader();
					reader.onload = () => {
						setFileImage(e.target.result);
					};
					reader.readAsDataURL(fileArchive);
				} else {
					setFormData({
						...formData,
						fileText: "El Tamaño Máximo de Subida de Document es de 10MB",
					});
					setErrors({ ...errors, messageArea: "", fileVerificacion: filterName });
				}
			}
		}
	};
	const handleInputDropdown = (event, { name, value }) => {
		setFormData({
			...formData,
			[name]: value,
			messageArea: "",
		});
	};
	const handleInputTextArea = (e) => {
		const { value } = e.target;
		let number = value;
		if (value.length > 499) {
			number = truncate(value, {
				length: 500,
				omission: "",
			});
		}

		setFormData({
			...formData,
			messageArea: number,
		});
	};
	// Modal
	const modalOpen = () => {
		if (isEqual(initialFormData, formData)) {
			cancelModal();
		} else if (open) {
			setOpen(false);
		} else {
			setOpen(true);
		}
	};

	const cancelModal = () => {
		onClose();
	};
	// render
	const removeTag = (item) => {
		if (modalOption !== "Watch") {
			const hashtagDelete = without(formData.hashtagData, item);
			setHastagDeletRepeat(item);
			setFormData({
				...formData,
				hashtagData: hashtagDelete,
			});
		}
	};
	const tagAdd = () => {
		if (!isEmpty(formData.hashtag)) {
			let hashtagNum = toLower(formData.hashtag);
			hashtagNum = hashtagNum.replace(/ /g, "");
			if (formData.hashtag[0] !== "#") {
				hashtagNum = `#${hashtagNum}`;
			}
			let verify = true;

			map(hashtagArray, (item) => {
				if (includes(hastagDeletRepeat, hashtagNum)) {
					const hashtagDelete = without(hastagDeletRepeat, hashtagNum);
					setHastagDeletRepeat(hashtagDelete);
				} else if (includes(item.hashtag, hashtagNum)) {
					verify = false;
				}
			});
			if (verify) {
				if (!includes(formData.hashtagData, hashtagNum)) {
					const hashtagUpdate = concat(formData.hashtagData, hashtagNum);

					setFormData({
						...formData,
						hashtagData: hashtagUpdate,
						hashtag: "",
					});
					setErrors({ ...errors, hashtagError: "" });
				} else {
					setErrors({ ...errors, hashtagError: "hashtag ya ha sido seleccionado" });
				}
			} else {
				setErrors({ ...errors, hashtagError: "hashtag ya Existe" });
			}
		}
	};

	const renderTag = useMemo(() => {
		let cont = 0;
		const renderHastag = map(formData.hashtagData, (item) => {
			cont += 1;
			return (
				<Label
					as="a"
					key={cont}
					className={styles.tagHashtag}
					onClick={() => {
						removeTag(item);
					}}>
					{item}
					<Icon disabled={modalOption === "Watch"} name="delete" />
				</Label>
			);
		});
		return renderHastag;
	}, [formData.hashtagData]);

	return (
		<Modal open closeIcon onClose={modalOpen}>
			<Modal.Header className="modalHeader">
				<div>
					{modalOption === "Watch" && <Icon name="eye" />}
					{modalOption === "Edit" && <Icon name="edit" />}
					{modalOption === "Add" && <Icon name="plus" />}
					{" Hashtag"}
					{modalOption !== "Add" && ` - Id: ${String(tableValue.id)}`}
				</div>
				<div>
					<div>
						{modalOption === "Watch" && (
							<Button
								onClick={() => {
									setModalOption("Edit");
								}}
								className="modalButtonEdit">
								<Icon name="edit" />
							</Button>
						)}

						{modalOption === "Edit" && (
							<Button
								onClick={() => {
									setModalOption("Watch");
								}}
								className="modalButtonWatch">
								<Icon name="eye" />
							</Button>
						)}
					</div>
				</div>
			</Modal.Header>
			<Modal.Content scrolling>
				<div className={styles.container}>
					<div className={styles.containerGroup}>
						<div className={styles.containerGroupR}>
							<Form>
								<Text className={isEmpty(errors.fileVerificacion) ? styles.textBox : styles.textBoxColor}>
									Formato:
									<span className={styles.required}>*</span>
								</Text>
								<Dropdown
									disabled={modalOption === "Watch"}
									value={formData.typeRadio}
									name="typeRadio"
									error={!isEmpty(errors.typeRadio)}
									onChange={archiveOptionHandler}
									placeholder="Elegir"
									fluid
									selection
									options={archiveOption}
								/>
								<Label
									className={styles.messageError}
									style={isEmpty(errors.fileVerificacion) ? { display: "none" } : null}
									pointing
									prompt>
									{errors.fileVerificacion}
								</Label>

								<div className={styles.rowNormal}>
									<Input
										value={formData.hashtag}
										disabled={modalOption === "Watch"}
										required
										icon="hashtag"
										label="Hashtag:"
										name="hashtag"
										fluid
										error={
											!isEmpty(errors.hashtagError) && {
												content: errors.hashtagError,
												pointing: "above",
											}
										}
										className={styles.inputChannel}
										onChange={handleInput}
									/>

									<Button
										disabled={modalOption === "Watch"}
										size="medium"
										fluid
										className={styles.buttomAdd}
										onClick={() => {
											tagAdd();
										}}>
										Agregar
									</Button>
								</div>
								<List className={styles.ListLabel} selection>
									<List.Item divided="horizontal">{renderTag}</List.Item>
								</List>
							</Form>
							{convertStringTitle(formData.typeRadio) !== "Desactivado" && (
								<div className={styles.rowImg}>
									<Text className={styles.textUrl}> {convertStringTitle(formData.typeRadio)} </Text>
									<div className={styles.row}>
										<button
											type="button"
											disabled={formData.typeRadio === "Text" ? true : modalOption === "Watch"}
											onClick={() => {
												return fileInputRef.current.click();
											}}>
											Seleccionar archivo
										</button>

										<Text disabled={formData.typeRadio === "Text"} className={styles.textFont}>
											{concatStringArchive(formData.fileText)}
										</Text>

										<Button
											icon="eye"
											disabled={!(!isEqual(formData.fileData, {}) && formData.typeRadio === "Image")}
											primary
											size="mini"
											onClick={() => {
												setOpenImage(true);
											}}
										/>
									</div>

									<input
										ref={fileInputRef}
										type="file"
										className={styles.inputImg}
										name="file"
										accept={convertStringArchive(formData.typeRadio)}
										onChange={fileChange}
										hidden
									/>
								</div>
							)}
							<Label
								className={styles.messageErrorTextBox}
								style={isEmpty(errors.fileVerificacion) ? { display: "none" } : null}
								pointing
								prompt>
								{errors.fileVerificacion}
							</Label>
						</div>

						<div className={styles.containerGroupR}>
							<Form>
								<Text className={isEmpty(errors.stateV) ? styles.textBox : styles.textBoxColor}>Estado:</Text>
								<Dropdown
									value={formData.stateV}
									name="stateV"
									disabled={modalOption === "Watch"}
									error={!isEmpty(errors.stateV)}
									onChange={handleInputDropdown}
									placeholder="Elegir"
									fluid
									selection
									options={boolOnline}
								/>
								<Label className={styles.messageError} style={isEmpty(errors.stateV) ? { display: "none" } : null} pointing prompt>
									{errors.stateV}
								</Label>

								<Form.Input
									label="Creado Por:"
									placeholder="Usuario"
									disabled={modalOption === "Watch"}
									icon="user"
									name="admin"
									readOnly
									fluid
									error={!isEmpty(errors.admin) && { content: errors.admin, pointing: "above" }}
									className={styles.inputChannel}
									value={formData.admin}
									onChange={handleInput}
								/>
							</Form>
						</div>
					</div>

					<Form>
						<Label className={styles.messageErrorTextBox} style={isEmpty(errors.messageArea) ? { display: "none" } : null} prompt>
							{errors.messageArea}
						</Label>
						<div className={styles.rowTitleImg}>
							<Text className={styles.textArea}> Texto: </Text>
							<Text className={get(formData, "messageArea", "").length === 500 ? styles.textAreaColor : styles.textArea}>
								{get(formData, "messageArea", "").length}
								/500
							</Text>
						</div>
						<TextareaAutosize
							disabled={formData.typeRadio === "Document" ? true : modalOption === "Watch"}
							value={formData.messageArea}
							name="messageArea"
							className={styles.textareaAutosize}
							onChange={handleInputTextArea}
							rows={1}
						/>
					</Form>
				</div>
			</Modal.Content>

			<Modal.Actions className={styles.modalHeader}>
				{modalOption === "Watch" ? (
					<Button className={styles.negativeButton} onClick={modalOpen}>
						Cerrar
					</Button>
				) : (
					<Button className={styles.negativeButton} onClick={modalOpen}>
						Atrás
					</Button>
				)}

				{modalOption !== "Watch" && (
					<Button className={styles.positiveButton} onClick={savedData}>
						{modalOption === "Add" ? "Guardar" : "Modificar"}
					</Button>
				)}
			</Modal.Actions>
			{open && (
				<ConfirmModal
					visible
					header="Confirmar"
					content="Está seguro que desea salir del formulario"
					onConfirm={cancelModal}
					onDismiss={modalOpen}
				/>
			)}
			{openImage && (
				<ImageView
					visible
					fileImage={fileImage}
					onClose={() => {
						return setOpenImage(false);
					}}
				/>
			)}
		</Modal>
	);
};

function mapStateToProps({ user }) {
	return { userName: user.name };
}
HashtagCrud.propTypes = {
	tableValue: PropTypes.array,
	userName: PropTypes.string,
	hashtagArray: PropTypes.array,
	apiData: PropTypes.func,
	onClose: PropTypes.func,
	dispatch: PropTypes.func,
	modalCrud: PropTypes.string,
};
export default connect(mapStateToProps)(HashtagCrud);
